











































  

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { WorkerWizardModule } from '@/store/modules/workerWizard';

@Component({
    name: 'WorkerWizardCsvUpload'
})
export default class WorkerWizardCsvUpload extends GiganautVueDialog {

    public dialog = false;

    currentFile: any = null;

    get hasWorkTypeSelected(): boolean {
        const workTypes = WorkerWizardModule.newWorker?.worker?.workTypes;
        return workTypes && workTypes.length > 0;
    }

    async save(){
        const formData = new FormData()
        formData.append('file', this.currentFile)
        await WorkerWizardModule.uploadWorkerCSV(formData);
        this.dialog = false;
    }

    @Watch('dialog')
    onDialogChanged(val: boolean) {
        if (val) {
            // Reset state when dialog opens
            this.currentFile = null;
        }
    }
}
